// removed by extract-text-webpack-plugin
module.exports = {"TrueBlack":"#000000","spotlight":"Ga1f7d1"};